import CoreInstance from '../CoreInstance';
import { localeFlag, getHeadersWithTokens } from '../ApiHelpers';

interface IArticle {
  id: number;
  babyId: number;
  locale?: string;
}
interface ICatalog {
  getCollectionGroups(locale: string, queries?: string): any;
  getCollectionGroupsAsOwner(locale: string, queries?: string): any;
  getCollection(id: number, queries: string, locale?: string): any;
  getIndexResults(queries: string, locale?: string): any;
  getCatalogFilters(locale?: string): any;
  getCatalogActivity(id: number, locale?: string): any;
  postComment(activityId: number, body: any, locale?: string): any;
  getArticle(article: IArticle): any;
}

const centers: ICatalog = {
  getCollectionGroups: (locale, queries = '') => CoreInstance.get(`/centers/collection_groups?${localeFlag(locale)}&${queries}`, getHeadersWithTokens(true)),
  getCollectionGroupsAsOwner: (locale, queries = '') => CoreInstance.get(`/organizations/collection_groups?${localeFlag(locale)}&${queries}`, getHeadersWithTokens(true)),
  getCollection: (id, queries, locale) => CoreInstance.get(`centers/collections/${id}?${queries}&${localeFlag(locale)}`),
  getCatalogFilters: (locale) => CoreInstance.get(`centers/catalog_filters?${localeFlag(locale)}`, getHeadersWithTokens(true)), getIndexResults: (queries) => CoreInstance.get(`centers/catalogs?${queries}&${localeFlag()}`, getHeadersWithTokens(true)),
  // getIndexResults: (queries) => CoreInstance.get(`centers/searcher?${queries}&${localeFlag()}`, getHeadersWithTokens(true)),
  getCatalogActivity: (id, locale) => CoreInstance.get(`centers/activities/${id}?${localeFlag(locale)}`),
  postComment: (activityId, body, locale) => CoreInstance.post(`centers/activities/${activityId}/comment?${localeFlag(locale)}`, body),
  getArticle: ({ id, babyId, locale }) => CoreInstance.get(`centers/babies/${babyId}/article?article_id=${id}&${localeFlag(locale)}`),
};

export default {
  centers,
};